import type { Command } from "prosemirror-state";

/**
 * When the cursor is on the first visual line of the first block in the document,
 * pressing ArrowUp focuses the page title textarea and places the cursor at its end.
 */
export const focusTitleOnArrowUp: Command = (state, dispatch, view) => {
	if (!view) return false;

	const { selection } = state;
	if (!selection.empty) return false;

	// Check if pressing up would leave the current textblock
	if (!view.endOfTextblock("up")) return false;

	// Ensure the cursor is in the very first position path through the document —
	// every ancestor node must be the first child of its parent.
	const $pos = selection.$from;
	for (let d = $pos.depth; d > 0; d--) {
		if ($pos.index(d - 1) !== 0) return false;
	}

	const titleEl = document.querySelector<HTMLTextAreaElement>("[data-page-title]");
	if (!titleEl) return false;

	if (!dispatch) return true;

	titleEl.focus();
	titleEl.selectionStart = titleEl.value.length;
	titleEl.selectionEnd = titleEl.value.length;

	return true;
};
